import React from 'react'
import PropTypes from 'prop-types'
import { Sparkles, Zap, MessageSquare, BarChart3 } from 'lucide-react'

import Modal from '../Modal/Modal'
import { Button } from '../../ui/button'

const FEATURES = [
  {
    icon: Sparkles,
    title: 'Fresh New Design',
    description: 'A modern, cleaner interface that makes managing your skating programs easier than ever.'
  },
  {
    icon: Zap,
    title: 'Improved Performance',
    description: 'Faster load times and a more responsive experience throughout the app.'
  },
  {
    icon: MessageSquare,
    title: 'In-App Messaging',
    description: 'Communicate directly with coaches, parents, and staff without leaving Leevo.'
  },
  {
    icon: BarChart3,
    title: 'New Reporting Tools',
    description: 'Better insights and data to help you track progress and manage your programs.'
  }
]

function WelcomeModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClickClose={onClose}
      onClickBackground={onClose}
      header="Welcome to the New Leevo!"
      headerColor="purple"
      size="lg"
      data-cy="welcome-modal"
    >
      <div className="space-y-5">
        <p className="text-gray-600 text-center">We&apos;ve been working hard to make Leevo better for you.</p>

        <div className="grid gap-3 sm:grid-cols-2">
          {FEATURES.map((feature) => {
            const IconComponent = feature.icon
            return (
              <div key={feature.title} className="flex gap-3 p-3 border border-gray-100 rounded-lg">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center w-9 h-9 bg-purple-50 rounded-lg">
                    <IconComponent className="w-4 h-4 text-purple-600" />
                  </div>
                </div>
                <div className="min-w-0">
                  <h3 className="font-medium text-gray-900 text-sm">{feature.title}</h3>
                  <p className="text-xs text-gray-500 leading-relaxed">{feature.description}</p>
                </div>
              </div>
            )
          })}
        </div>

        <div className="flex justify-center pt-1">
          <Button onClick={onClose} className="bg-purple-600 hover:bg-purple-700 px-8" data-cy="welcome-modal-dismiss">
            Got it!
          </Button>
        </div>
      </div>
    </Modal>
  )
}

WelcomeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default WelcomeModal
